"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnvironmentService = void 0;
const VALID_ENVIRONMENTS = new Set(['prod', 'stage', 'qa', 'perf']);
class EnvironmentService {
    static getEnvironment() {
        const value = globalThis.window?.ENVIRONMENT;
        if (value && VALID_ENVIRONMENTS.has(value)) {
            return value;
        }
        return undefined;
    }
    static isEnvironment(env) {
        return EnvironmentService.getEnvironment() === env;
    }
}
exports.EnvironmentService = EnvironmentService;
